import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import {
  Link,
  LinkIcon
} from '../'
import Styles from './ExclusionsStatsBox.css'


@CSSModules(Styles, {allowMultiple:true})
class ExclusionsStatsBoxRow extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    val1: PropTypes.string.isRequired,
    val2: PropTypes.string.isRequired,
    val3: PropTypes.string.isRequired,
    mod:  PropTypes.string,
    icon: PropTypes.number,
    indent: PropTypes.number,
  }
  //
  constructor(props){
    super(props)
    this.state = {
      cellStyleMod: props.mod ? 'cell-label--'+props.mod : ''
    }
  }
  //
  render() {
    return <div styleName='exclusions-stats-box__row'>
      <div styleName={'exclusions-stats-box__cell-label '+this.state.cellStyleMod}>
        {
          this.props.indent ?
            <span>&nbsp;&nbsp;</span> :
            null
        }
        {
          this.props.icon ?
            <span>
              <LinkIcon faclass='fa-exclamation-triangle' nospace/>
              &nbsp;
              &nbsp;
            </span> :
            null
        }
        {this.props.label}
      </div>
      <div styleName={'exclusions-stats-box__cell-val-1 '+this.state.cellStyleMod}>
        {this.props.val1}
      </div>
      <div styleName={'exclusions-stats-box__cell-val-2 '+this.state.cellStyleMod}>
        {this.props.val2}
      </div>
      <div styleName={'exclusions-stats-box__cell-val-3 '+this.state.cellStyleMod}>
        {this.props.val3}
      </div>
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
export default class ExclusionsStatsBox extends Component {
  static propTypes = {
    issueId: PropTypes.string.isRequired,
    fund: PropTypes.object.isRequired,
    shareClass: PropTypes.object.isRequired,
  }
  constructor(props){
    super(props)

    const linkText = {
      pff: 'prisons & borders',
      wff: 'military weapons',
    }[this.props.issueId] || ''

    const linkBaseUrl = {
      pff: 'prison',
      wff: 'weapon',
    }[this.props.issueId] || ''

    const linkProfilePath = {
      pff: 'prison-industrial-complex',
      wff: 'weapon',
    }[this.props.issueId] || ''

    const name = format.sanitize(props.fund.fund_legal_name)
    const ticker = props.shareClass.ticker ? props.shareClass.ticker : 'N'

    // https://weaponfreefunds.org/fund/parnassus-core-equity-fund/PRILX/weapon-investments/FSUSA001WD/FOUSA05HGA
    // https://prisonfreefunds.org/fund/parnassus-core-equity-fund/PRILX/prison-industrial-complex-investments/FSUSA001WD/FOUSA05HGA

    const linkFullUrl = `https://${linkBaseUrl}freefunds.org/fund/${name}/${ticker}/${linkProfilePath}-investments/${props.fund.fund_id}/${props.shareClass.investment_vehicle_id}`

    const fm = (v) => { return format.money(v, true, 'USD', true) }

    const pffConfig = [
      [
        'Prisons',
        props.fund.pp_count,
        fm(props.fund.pp_asset),
        format.perc(props.fund.pp_weight),
        '',
        0, // icon
        0, // indent
      ],
      [
        'Prisons high risk',
        props.fund.pp_high_count,
        fm(props.fund.pp_high_asset),
        format.perc(props.fund.pp_high_weight),
        '',
        1, // icon
        1, // indent
      ],
      [
        'Private prisons',
        props.fund.pff_all_extreme_count,
        fm(props.fund.pff_all_extreme_asset),
        format.perc(props.fund.pff_all_extreme_weight),
        'red',
        1, // icon
        1, // indent
      ],
      [
        'Borders',
        props.fund.borders_count,
        fm(props.fund.borders_asset),
        format.perc(props.fund.borders_weight),
        '',
        0, // icon
        0, // indent
      ],
      [
        'Borders high risk',
        props.fund.borders_high_count,
        fm(props.fund.borders_high_asset),
        format.perc(props.fund.borders_high_weight),
        '',
        1, // icon
        1, // indent
      ],
      [
        'Total',
        props.fund.pff_all_count,
        fm(props.fund.pff_all_asset),
        format.perc(props.fund.pff_all_weight),
        'bold',
        0, // icon
        0, // indent
      ],
    ]

    const wffConfig = [
      [
        'Military contractors',
        props.fund.mmc_count,
        fm(props.fund.mmc_asset),
        format.perc(props.fund.mmc_weight),
        '',
        0, // icon
        0, // indent
      ],
      [
        'Nuclear weapons',
        props.fund.nw_count,
        fm(props.fund.nw_asset),
        format.perc(props.fund.nw_weight),
        '',
        1, // icon
        1, // indent
      ],
      [
        'Controversial weapons',
        props.fund.cm_count,
        fm(props.fund.cm_asset),
        format.perc(props.fund.cm_weight),
        '',
        1, // icon
        1, // indent
      ],
      [
        'Total',
        props.fund.wff_mil_count,
        fm(props.fund.wff_mil_asset),
        format.perc(props.fund.wff_mil_weight),
        'bold',
        0, // icon
        0, // indent
      ],
    ]

    this.state = {
      linkText,
      linkFullUrl,
      rowConfig: props.issueId === 'pff' ? pffConfig : wffConfig
    }
  }
  //
  render() {
    return <div styleName='exclusions-stats-box'>

      <h3 styleName='exclusions-stats-box__title'>
        Totals
      </h3>

      <ExclusionsStatsBoxRow
        label='' val1='Holdings' val2='Assets' val3='Weight' mod='bold'
      />

      {
        this.state.rowConfig.map((e, i) => {
          return <ExclusionsStatsBoxRow
            label={e[0]} val1={e[1]} val2={e[2]} val3={e[3]} mod={e[4]}
            icon={e[5]} indent={e[6]} key={'ExclusionsStatsBoxRow-'+i}
          />
        })
      }

      <Link strong to={this.state.linkFullUrl} title='See full fund results'>
        Full fund results<LinkIcon />
      </Link>

    </div>
  }
}

